import { isDevMode } from "@angular/core";

import { environment } from "@azm/environments/environment";

const DEFAULT_IDLE_SECONDS = 600;
const DEFAULT_LAST_ACTIVITY_KEY = "ensaf-last-activity";

export function isIdleMonitoringEnabled(): boolean {
	if (environment.idle?.enabled === false) {
		return false;
	}

	if (isDevMode()) {
		return false;
	}

	return true;
}

export function getIdleTimeoutSeconds(): number {
	const timeoutSeconds = environment.idle?.timeoutSeconds;
	return typeof timeoutSeconds === "number" && timeoutSeconds > 0 ? timeoutSeconds : DEFAULT_IDLE_SECONDS;
}

export function getIdleLastActivityKey(): string {
	const key = environment.idle?.lastActivityKey?.trim();
	return key || DEFAULT_LAST_ACTIVITY_KEY;
}

export function isIdlePublicRoute(url: string): boolean {
	const path = (url.split("?")[0] || "/").replace(/\/$/, "") || "/";

	if (path === "/") {
		return true;
	}

	if (path.startsWith("/auth")) {
		return true;
	}

	if (path.startsWith("/token-access-error")) {
		return true;
	}

	if (path.startsWith("/decisions")) {
		return true;
	}

	if (path.startsWith("/sample")) {
		return true;
	}

	return false;
}
